module.exports = __webpack_public_path__ + "static/media/24UHCHR24.a8582fc1.jpg";